import { Injectable, NgZone } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class AuthActivityService {
  private readonly baseUrl = environment.apiBaseUrl;

  private readonly heartbeatEveryMs = 5 * 60 * 1000; // 5 minutes
  private readonly storageKey = 'last_heartbeat_at';

  private started = false;

  constructor(
    private http: HttpClient,
    private zone: NgZone,
  ) {}

  start(): void {
    if (this.started) return;

    this.started = true;

    this.zone.runOutsideAngular(() => {
      ['click', 'keydown', 'touchstart'].forEach((eventName) => {
        window.addEventListener(
          eventName,
          () => this.tryHeartbeat(),
          { passive: true }
        );
      });
    });
  }

  private tryHeartbeat(): void {
    if (!localStorage.getItem('auth_token')) {
      return;
    }

    const now = Date.now();

    const lastHeartbeatAt = Number(
      localStorage.getItem(this.storageKey) || 0
    );

    if (now - lastHeartbeatAt < this.heartbeatEveryMs) {
      return;
    }

    localStorage.setItem(this.storageKey, String(now));

    this.http.post(`${this.baseUrl}heartbeat`, {}).subscribe({
      error: () => {
        // ignore heartbeat errors
      },
    });
  }
}